export enum QuestionType {
  Undefined = 'Undefined',
  Amount = 'Amount',
  Textarea = 'Textarea',
  Input = 'Input',
  Datepicker = 'Datepicker',
  Dropdown = 'Dropdown',
  RadioButton = 'RadioButton',
  InputTable = 'InputTable',
  Repeater = 'Repeater',
  Checkbox = 'Checkbox',
  Information = 'Information',
  FileUpload = 'FileUpload',
  Worksite = 'Worksite',
  Person = 'Person',
  Classification = 'Classification',
  Budget = 'Budget',
}
